const createHistory = require('history').createBrowserHistory;
const history = createHistory();

export default history;
